import { ReactElement } from "react";

export function FormattedNumber({
  locale,
  value,
  currency,
}: {
  locale: string;
  value: number;
  currency?: string;
}): ReactElement {
  return (
    <>
      {new Intl.NumberFormat(
        locale,
        currency
          ? {
              style: "currency",
              currency,
              ...(value % 1 === 0
                ? { minimumFractionDigits: 0, maximumFractionDigits: 0 }
                : { minimumFractionDigits: 2 }),
            }
          : {}
      )
        .format(value)
        .replace(/\s+/g, " ")}
    </>
  );
}
